import { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import styles from './rentrolllist.module.css';
import { Link } from "react-router-dom";
import dayjs from 'dayjs';
import { ChevronDown, ChevronUp, Code } from 'react-feather';

const RentRollList = ({ rentrollList }) => {
    const [sortItem, setSortItem] = useState("");
    const [sortOrder, setSortOrder] = useState("");

    const changeSortOrder = (type) => {
        if (type === sortItem) {
            if (sortOrder === "asc") {
                setSortOrder("desc");
            } else {
                setSortOrder("asc");
            }
        } else {
            setSortOrder("asc");
        }
        setSortItem(type);
    };

    const sortedRentRollList = [...(rentrollList || [])].sort((a, b) => {
        if (!sortItem) return 0;

        if (sortItem === "property_name") {
            const valA = a?.property_name || "";
            const valB = b?.property_name || "";
            return sortOrder === "asc"
                ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' })
                : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
        }
        if (sortItem === "apt_no") {
            const valA = (a?.apt_no || "").toString();
            const valB = (b?.apt_no || "").toString();
            return sortOrder === "asc"
                ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' })
                : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
        }
        if (sortItem === "bd_ba") {
            const valA = (a?.bd_ba || "").toString();
            const valB = (b?.bd_ba || "").toString();
            return sortOrder === "asc"
                ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' })
                : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
        }
        if (sortItem === "tenant_name") {
            const valA = a?.current_tenant ? (a?.tenant_name || "") : "";
            const valB = b?.current_tenant ? (b?.tenant_name || "") : "";
            if (!valA && valB) return 1;
            if (valA && !valB) return -1;
            return sortOrder === "asc"
                ? valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' })
                : valB.localeCompare(valA, undefined, { numeric: true, sensitivity: 'base' });
        }
        if (sortItem === "current_status") {
            const valA = Number(a?.current_status) || 0;
            const valB = Number(b?.current_status) || 0;
            return sortOrder === "asc" ? valA - valB : valB - valA;
        }
        if (sortItem === "size") {
            const valA = parseFloat(a?.size) || 0;
            const valB = parseFloat(b?.size) || 0;
            return sortOrder === "asc" ? valA - valB : valB - valA;
        }
        if (sortItem === "actual_rent") {
            const valA = a?.actual_rent !== "" && a?.actual_rent !== null && a?.actual_rent !== undefined ? parseFloat(a?.actual_rent) : -1;
            const valB = b?.actual_rent !== "" && b?.actual_rent !== null && b?.actual_rent !== undefined ? parseFloat(b?.actual_rent) : -1;
            if (valA === -1 && valB !== -1) return 1;
            if (valA !== -1 && valB === -1) return -1;
            return sortOrder === "asc" ? valA - valB : valB - valA;
        }
        if (sortItem === "security_deposit") {
            const valA = a?.security_deposit !== "" && a?.security_deposit !== null && a?.security_deposit !== undefined ? parseFloat(a?.security_deposit) : -1;
            const valB = b?.security_deposit !== "" && b?.security_deposit !== null && b?.security_deposit !== undefined ? parseFloat(b?.security_deposit) : -1;
            if (valA === -1 && valB !== -1) return 1;
            if (valA !== -1 && valB === -1) return -1;
            return sortOrder === "asc" ? valA - valB : valB - valA;
        }
        if (sortItem === "movein_date") {
            const valA = a?.movein_date ? dayjs(a.movein_date).valueOf() : 0;
            const valB = b?.movein_date ? dayjs(b.movein_date).valueOf() : 0;
            if (!valA && valB) return 1;
            if (valA && !valB) return -1;
            return sortOrder === "asc" ? valA - valB : valB - valA;
        }
        return 0;
    });

    return (<div className={`${styles.IncomeListUnderSec}`}>

        {sortedRentRollList?.map((item, index) => {
            return <div key={index} className={`${styles.ListCardDivSec}`}>
                <div className={`${styles.CardDivList}`}>
                    <div className={`${styles.FirstSec} ${styles.ProfileImg}`}>
                        {/* <img src="/static/img/avatars/avatar-4.jpg" alt="" /> */}
                        <div>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                {item?.current_tenant ? <Link to={'/people/tenants/details/' + item?.current_tenant}>{item?.tenant_name}</Link> : '-'}
                            </p>
                            <p className={`${styles.Name} ${styles.Hover}`}>
                                <Link to={'/properties/details/' + item?.property_id}>{item?.property_name} - {item?.apt_no}</Link>
                            </p>
                        </div>
                    </div>
                    <div className={`${styles.SecondSec}`}>
                        <p className={`${styles.Name}`}>
                            <span>BD/BA: <span>{item?.bd_ba}</span></span>
                            <span className={`${styles.Second}`}>Sqft: <span>{item?.size}</span></span>
                        </p>
                        <p className={`${styles.Name}`}>
                            <span>Rent: <span>{item?.actual_rent !== '' ? '$' + item?.actual_rent : '-'}</span></span>
                            <span className={`${styles.Second}`}><span>Deposit: {item?.security_deposit !== '' ? '$' + item?.security_deposit : '-'}</span></span>
                        </p>
                    </div>
                    <div className={`${styles.ThirdSec}`}>
                        {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Confirm}`}>Rented</span>}
                        {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.NotVerified}`}>Available</span>}
                        {item?.current_status !== 1 && item?.current_status !== 2 && <span className={`${styles.StatusBadge} ${styles.Failed}`}>Not Available</span>}
                        <p className={`${styles.Name}`}>
                            <span>Move-In: <span>{item?.movein_date !== '' ? dayjs(item?.movein_date).format('MM-DD-YYYY') : '-'}</span></span>
                        </p>
                    </div>
                </div>
            </div>
        })}

        {sortedRentRollList?.length > 0 && <TableContainer className={`${styles.TableDiv} CustomTableDiv`}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 200 }} onClick={() => changeSortOrder("property_name")}>
                            Property
                            {sortItem === "property_name" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "property_name" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "property_name" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 100 }} onClick={() => changeSortOrder("apt_no")}>
                            Unit
                            {sortItem === "apt_no" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "apt_no" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "apt_no" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 120 }} onClick={() => changeSortOrder("bd_ba")}>
                            BD/BA
                            {sortItem === "bd_ba" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "bd_ba" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "bd_ba" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 180 }} onClick={() => changeSortOrder("tenant_name")}>
                            Tenant
                            {sortItem === "tenant_name" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "tenant_name" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "tenant_name" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={() => changeSortOrder("current_status")}>
                            Status
                            {sortItem === "current_status" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "current_status" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "current_status" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 120 }} onClick={() => changeSortOrder("size")}>
                            Sqft
                            {sortItem === "size" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "size" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "size" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={() => changeSortOrder("actual_rent")}>
                            Rent
                            {sortItem === "actual_rent" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "actual_rent" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "actual_rent" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={() => changeSortOrder("security_deposit")}>
                            Deposit
                            {sortItem === "security_deposit" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "security_deposit" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "security_deposit" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                        <TableCell className={`${styles.TableHead}`} style={{ width: 150 }} onClick={() => changeSortOrder("movein_date")}>
                            Move-In
                            {sortItem === "movein_date" && sortOrder === "asc" && <ChevronDown />}
                            {sortItem === "movein_date" && sortOrder === "desc" && <ChevronUp />}
                            {sortItem !== "movein_date" && <Code className={`${styles.Normal}`} />}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedRentRollList?.map((item, index) => {
                        return <TableRow key={index}>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}><Link to={'/properties/details/' + item?.property_id}><span>{item?.property_name}</span></Link></TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.apt_no}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.bd_ba}</TableCell>
                            <TableCell className={`${styles.TableBodyText} ${styles.ProfileImg} ${styles.Hover}`}>{item?.current_tenant ? <Link to={'/people/tenants/details/' + item?.current_tenant}><span>{item?.tenant_name}</span></Link> : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>
                                {item?.current_status === 2 && <span className={`${styles.StatusBadge} ${styles.Confirm}`}>Rented</span>}
                                {item?.current_status === 1 && <span className={`${styles.StatusBadge} ${styles.NotVerified}`}>Available</span>}
                                {item?.current_status !== 1 && item?.current_status !== 2 && <span className={`${styles.StatusBadge} ${styles.Failed}`}>Not Available</span>}
                            </TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.size}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.actual_rent !== '' ? item?.actual_rent?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.security_deposit !== '' ? item?.security_deposit?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            }) : '-'}</TableCell>
                            <TableCell className={`${styles.TableBodyText}`}>{item?.movein_date !== '' ? dayjs(item?.movein_date).format('MM-DD-YYYY') : '-'}</TableCell>
                        </TableRow>
                    })}

                </TableBody>
            </Table>
        </TableContainer>}

        {sortedRentRollList?.length === 0 && <div className={`${styles.NoDataMain}`}>
            <div className={`${styles.NoDataIMG}`}>
                <img src="/static/img/no-report.png" alt="No Data" />
            </div>
            <p className={`${styles.NoDataText}`}>Rent roll list is currently empty.</p>
            <p className={`${styles.NoDataTextSub}`}>All your reports will appear here once available.</p>
        </div>}

    </div>);
}

export default RentRollList;